let province_wrappers = document.querySelectorAll('.c-province_wrapper');
let typingTimer;               
let typeInterval = 500;  
let searchInput = document.getElementById('searchbox');
let searchInputForm = document.getElementById('searchbox_form');
let searchInputChb = document.querySelectorAll('.checkbox_wrapper input');
let searchResultNone = document.querySelector('.c-result_none');
let search_chb_list = [];
let disp_num = 0;
let hidden_num = 0;
const searchInputChbTitle = document.querySelectorAll('.c-SearchChbTitle_Wrapper');
    
function liveSearch() {
  search_chb_list = [];
  disp_num=0;
  hidden_num=0;
  let search_query = document.getElementById("searchbox").value;
  searchInputChb.forEach((chb_item)=>{
    if (chb_item.checked) { 
      //チェックボックスの県名を格納
      search_chb_list.push(chb_item.value)
    }
  });
  //First Message非表示
  document.querySelector('.c-ClinicSearchSection .c-FirstMessage').classList.add("hidden");

    province_wrappers.forEach((province)=>{
      //クリニック名で部分一致
      let searched_name_flg = false;
      for (var i = 0; i < province.querySelectorAll('.c-clinic_name').length; i++) {
        if(province.querySelectorAll('.c-clinic_name')[i].textContent.includes(search_query)){
          searched_name_flg=true;
          break;
        }
      };
      //住所で部分一致
      let searched_address_flg = false;
      for (var i = 0; i < province.querySelectorAll('.c-clinic_address').length; i++) {
        if(province.querySelectorAll('.c-clinic_address')[i].textContent.includes(search_query)){
          searched_address_flg=true;
          break;
        }
      };
      //郵便番号で部分一致（8文字以内かつ半角数字とハイフンのみの場合）
      let searched_zip_flg = false;
      const isZipFormat = /^[0-9\-]+$/.test(search_query) && search_query.length <= 8;
      if(isZipFormat){
        for (var i = 0; i < province.querySelectorAll('.c-clinic_item').length; i++) {
          const zipData = province.querySelectorAll('.c-clinic_item')[i].getAttribute('data-zip');
          const zipDataRemovedHyphen = zipData.replace(/-/g, '');
          const searchQueryRemovedHyphen = search_query.replace(/-/g, '');
          if(zipData && zipDataRemovedHyphen.includes(searchQueryRemovedHyphen)){
            searched_zip_flg=true;
            break;
          }
        }
      }

      if(search_query !== ""
        &&
        search_chb_list.length > 0
      ){
        //テキストボックスとチェックボックスあり、かつ両方にヒット　→表示
        if((searched_name_flg || searched_address_flg || searched_zip_flg)
          &&
          search_chb_list.indexOf(province.querySelector(".c-ProvinceTitle").textContent)>-1
        ){
          //テキストボックスのみ、かつテキストボックスにヒット　→表示
          province.classList.remove("hidden");
          disp_num++;

          //県内の、フリーワードにヒットしないクリニックは非表示
          province.querySelectorAll('.c-clinic_item').forEach((item)=>{
            const zipData = item.getAttribute('data-zip');
            const zipDataRemovedHyphen = zipData.replace(/-/g, '');
            const searchQueryRemovedHyphen = search_query.replace(/-/g, '');
            const isZipFormat = /^[0-9\-]+$/.test(search_query) && search_query.length <= 8;
            if(item.querySelector('.c-clinic_name').textContent.includes(search_query)
              || 
              item.querySelector('.c-clinic_address').textContent.includes(search_query)
              ||
              (isZipFormat && zipData && zipDataRemovedHyphen.includes(searchQueryRemovedHyphen))){
              item.classList.remove("hidden");
            }else{
              item.classList.add("hidden");
            }
          });
        }else{
          province.classList.add("hidden");
        }
      }else if(search_query !== ""
          &&
          (searched_name_flg || searched_address_flg || searched_zip_flg)
      ){
        //テキストボックスのみ、かつテキストボックスにヒット　→表示
        province.classList.remove("hidden");
        disp_num++;

        //県内の、フリーワードにヒットしないクリニックは非表示
        province.querySelectorAll('.c-clinic_item').forEach((item)=>{
          const zipData = item.getAttribute('data-zip');
          const zipDataRemovedHyphen = zipData.replace(/-/g, '');
          const searchQueryRemovedHyphen = search_query.replace(/-/g, '');
          const isZipFormat = /^[0-9\-]+$/.test(search_query) && search_query.length <= 8;
          if(item.querySelector('.c-clinic_name').textContent.includes(search_query)
            || 
            item.querySelector('.c-clinic_address').textContent.includes(search_query)
            ||
            (isZipFormat && zipData && zipDataRemovedHyphen.includes(searchQueryRemovedHyphen))){
            item.classList.remove("hidden");
          }else{
            item.classList.add("hidden");
          }
        });
      }else if(search_chb_list.indexOf(province.querySelector(".c-ProvinceTitle").textContent)>-1){
        //チェックボックスのみ、かつチェックボックスにヒット　→表示
        province.classList.remove("hidden");
        disp_num++;

        //県内の、クリニックは全て表示
        province.querySelectorAll('.c-clinic_item').forEach((item)=>{
          item.classList.remove("hidden");
        });
      } else {
        //それ以外は非表示
        province.classList.add("hidden");
        hidden_num++
      }

      if(search_query === "" && document.querySelectorAll('.checkbox_wrapper input:checked').length === 0){
        //検索欄に入力ない場合、全て非表示
        province.classList.add("hidden");
        hidden_num++;
      }
    });

  if(disp_num === 0){
    searchResultNone.classList.remove("hidden");
  }else{
    searchResultNone.classList.add("hidden");
  }

  //ダイアログ通知
  document.querySelector('.c-ClinicSearchDialogWrapper').classList.add("open");
  setTimeout(()=>{
    document.querySelector('.c-ClinicSearchDialogWrapper').classList.remove("open")
  },3000);
}

//フリーワード入力時
searchInputForm.addEventListener('submit', (e) => {
    e.preventDefault();
    clearTimeout(typingTimer);
    typingTimer = setTimeout(liveSearch, typeInterval);
});
//チェックボックス入力時
searchInputChb.forEach((chb_item)=>{
  chb_item.addEventListener('click', () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(liveSearch, typeInterval);
  });
});

//検索欄 - チェックボックス一覧のアコーディオン制御
searchInputChbTitle.forEach((title_item)=>{
  title_item.addEventListener('click', () => {
    const content = title_item.nextElementSibling;
    title_item.classList.toggle("is-active");
    content.classList.toggle("is-open");
  })
});


document.addEventListener('DOMContentLoaded', function () {
  //都道府県 HTML追加箇所
  const elem_hokkaido = document.getElementById('cliniclist-hokkaido'),
    elem_aomori = document.getElementById('cliniclist-aomori'),
    elem_iwate = document.getElementById('cliniclist-iwate'),
    elem_miyagi = document.getElementById('cliniclist-miyagi'),
    elem_akita = document.getElementById('cliniclist-akita'),
    elem_yamagata = document.getElementById('cliniclist-yamagata'),
    elem_fukusima = document.getElementById('cliniclist-fukusima'),
    elem_ibaragi = document.getElementById('cliniclist-ibaragi'),
    elem_tochigi = document.getElementById('cliniclist-tochigi'),
    elem_gunma = document.getElementById('cliniclist-gunma'),
    elem_saitama = document.getElementById('cliniclist-saitama'),
    elem_chiba = document.getElementById('cliniclist-chiba'),
    elem_tokyo = document.getElementById('cliniclist-tokyo'),
    elem_kanagawa = document.getElementById('cliniclist-kanagawa'),
    elem_nigata = document.getElementById('cliniclist-nigata'),
    elem_toyama = document.getElementById('cliniclist-toyama'),
    elem_isikawa = document.getElementById('cliniclist-isikawa'),
    elem_fukui = document.getElementById('cliniclist-fukui'),
    elem_yamanasi = document.getElementById('cliniclist-yamanasi'),
    elem_nagano = document.getElementById('cliniclist-nagano'),
    elem_gifu = document.getElementById('cliniclist-gifu'),
    elem_sizuoka = document.getElementById('cliniclist-sizuoka'),
    elem_aichi = document.getElementById('cliniclist-aichi'),
    elem_mie = document.getElementById('cliniclist-mie'),
    elem_siga = document.getElementById('cliniclist-siga'),
    elem_kyouto = document.getElementById('cliniclist-kyouto'),
    elem_osaka = document.getElementById('cliniclist-osaka'),
    elem_hyougo = document.getElementById('cliniclist-hyougo'),
    elem_nara = document.getElementById('cliniclist-nara'),
    elem_wakayama = document.getElementById('cliniclist-wakayama'),
    elem_tottori = document.getElementById('cliniclist-tottori'),
    elem_shimane = document.getElementById('cliniclist-shimane'),
    elem_okayama = document.getElementById('cliniclist-okayama'),
    elem_hiroshima = document.getElementById('cliniclist-hiroshima'),
    elem_yamaguti = document.getElementById('cliniclist-yamaguti'),
    elem_tokusima = document.getElementById('cliniclist-tokusima'),
    elem_kagawa = document.getElementById('cliniclist-kagawa'),
    elem_ehime = document.getElementById('cliniclist-ehime'),
    elem_kouchi = document.getElementById('cliniclist-kouchi'),
    elem_fukuoka = document.getElementById('cliniclist-fukuoka'),
    elem_saga = document.getElementById('cliniclist-saga'),
    elem_nagasaki = document.getElementById('cliniclist-nagasaki'),
    elem_kumamoto = document.getElementById('cliniclist-kumamoto'),
    elem_ooita = document.getElementById('cliniclist-ooita'),
    elem_miyazaki = document.getElementById('cliniclist-miyazaki'),
    elem_kagosima = document.getElementById('cliniclist-kagosima'),
    elem_okinawa = document.getElementById('cliniclist-okinawa');

  //都道府県 div追加要素を生成
  const addelem_wrapper_hokkaido = document.createElement('div'),
    addelem_wrapper_aomori = document.createElement('div'),
    addelem_wrapper_iwate = document.createElement('div'),
    addelem_wrapper_miyagi = document.createElement('div'),
    addelem_wrapper_akita = document.createElement('div'),
    addelem_wrapper_yamagata = document.createElement('div'),
    addelem_wrapper_fukusima = document.createElement('div'),
    addelem_wrapper_ibaragi = document.createElement('div'),
    addelem_wrapper_tochigi = document.createElement('div'),
    addelem_wrapper_gunma = document.createElement('div'),
    addelem_wrapper_saitama = document.createElement('div'),
    addelem_wrapper_chiba = document.createElement('div'),
    addelem_wrapper_tokyo = document.createElement('div'),
    addelem_wrapper_kanagawa = document.createElement('div'),
    addelem_wrapper_nigata = document.createElement('div'),
    addelem_wrapper_toyama = document.createElement('div'),
    addelem_wrapper_isikawa = document.createElement('div'),
    addelem_wrapper_fukui = document.createElement('div'),
    addelem_wrapper_yamanasi = document.createElement('div'),
    addelem_wrapper_nagano = document.createElement('div'),
    addelem_wrapper_gifu = document.createElement('div'),
    addelem_wrapper_sizuoka = document.createElement('div'),
    addelem_wrapper_aichi = document.createElement('div'),
    addelem_wrapper_mie = document.createElement('div'),
    addelem_wrapper_siga = document.createElement('div'),
    addelem_wrapper_kyouto = document.createElement('div'),
    addelem_wrapper_osaka = document.createElement('div'),
    addelem_wrapper_hyougo = document.createElement('div'),
    addelem_wrapper_nara = document.createElement('div'),
    addelem_wrapper_wakayama = document.createElement('div'),
    addelem_wrapper_tottori = document.createElement('div'),
    addelem_wrapper_shimane = document.createElement('div'),
    addelem_wrapper_okayama = document.createElement('div'),
    addelem_wrapper_hiroshima = document.createElement('div'),
    addelem_wrapper_yamaguti = document.createElement('div'),
    addelem_wrapper_tokusima = document.createElement('div'),
    addelem_wrapper_kagawa = document.createElement('div'),
    addelem_wrapper_ehime = document.createElement('div'),
    addelem_wrapper_kouchi = document.createElement('div'),
    addelem_wrapper_fukuoka = document.createElement('div'),
    addelem_wrapper_saga = document.createElement('div'),
    addelem_wrapper_nagasaki = document.createElement('div'),
    addelem_wrapper_kumamoto = document.createElement('div'),
    addelem_wrapper_ooita = document.createElement('div'),
    addelem_wrapper_miyazaki = document.createElement('div'),
    addelem_wrapper_kagosima = document.createElement('div'),
    addelem_wrapper_okinawa = document.createElement('div');


  //都道府県 要素作成関数
  const addClinicByProvince = (_clinics) => {
    //クリニック表示処理
    _clinics.forEach((clinic) => {
      let addelem_wrapper = '';
      let addelem = '';
      let addelem_name = '';
      let addelem_state = '';
      let addelem_tel = '';
      //Wrapper要素
      addelem = document.createElement('div');
      addelem.className = 'c-clinic_item';

      //クリニック名要素作成
      addelem_name = document.createElement('p');
      addelem_name.className = 'c-clinic_name';
      addelem_name.textContent = clinic.VICS正式名称;

      //住所要素作成
      addelem_state = document.createElement('p');
      addelem_state.className = 'c-clinic_address';
      addelem_state.textContent = clinic.住所;

      //電話番号要素作成
      addelem_tel = document.createElement('p');
      addelem_tel.className = 'c-clinic_tel';
      addelem_tel.textContent = clinic.TEL;

      //Wrapper要素に追加
      addelem.appendChild(addelem_name);
      addelem.appendChild(addelem_state);
      addelem.appendChild(addelem_tel);

      // 郵便番号をdata属性に追加
      if(clinic.ZIP?.length > 0){
        addelem.setAttribute('data-zip', clinic.ZIP);
      }

      //都道府県の該当要素へ追加
      if (clinic.都道府県 === '北海道') {
        addelem_wrapper_hokkaido.appendChild(addelem);
      } else if (clinic.都道府県 === '青森県') {
        addelem_wrapper_aomori.appendChild(addelem);
      } else if (clinic.都道府県 === '岩手県') {
        addelem_wrapper_iwate.appendChild(addelem);
      } else if (clinic.都道府県 === '宮城県') {
        addelem_wrapper_miyagi.appendChild(addelem);
      } else if (clinic.都道府県 === '秋田県') {
        addelem_wrapper_akita.appendChild(addelem);
      } else if (clinic.都道府県 === '山形県') {
        addelem_wrapper_yamagata.appendChild(addelem);
      } else if (clinic.都道府県 === '福島県') {
        addelem_wrapper_fukusima.appendChild(addelem);
      } else if (clinic.都道府県 === '茨城県') {
        addelem_wrapper_ibaragi.appendChild(addelem);
      } else if (clinic.都道府県 === '栃木県') {
        addelem_wrapper_tochigi.appendChild(addelem);
      } else if (clinic.都道府県 === '群馬県') {
        addelem_wrapper_gunma.appendChild(addelem);
      } else if (clinic.都道府県 === '埼玉県') {
        addelem_wrapper_saitama.appendChild(addelem);
      } else if (clinic.都道府県 === '千葉県') {
        addelem_wrapper_chiba.appendChild(addelem);
      } else if (clinic.都道府県 === '東京都') {
        addelem_wrapper_tokyo.appendChild(addelem);
      } else if (clinic.都道府県 === '神奈川県') {
        addelem_wrapper_kanagawa.appendChild(addelem);
      } else if (clinic.都道府県 === '新潟県') {
        addelem_wrapper_nigata.appendChild(addelem);
      } else if (clinic.都道府県 === '富山県') {
        addelem_wrapper_toyama.appendChild(addelem);
      } else if (clinic.都道府県 === '石川県') {
        addelem_wrapper_isikawa.appendChild(addelem);
      } else if (clinic.都道府県 === '福井県') {
        addelem_wrapper_fukui.appendChild(addelem);
      } else if (clinic.都道府県 === '山梨県') {
        addelem_wrapper_yamanasi.appendChild(addelem);
      } else if (clinic.都道府県 === '長野県') {
        addelem_wrapper_nagano.appendChild(addelem);
      } else if (clinic.都道府県 === '岐阜県') {
        addelem_wrapper_gifu.appendChild(addelem);
      } else if (clinic.都道府県 === '静岡県') {
        addelem_wrapper_sizuoka.appendChild(addelem);
      } else if (clinic.都道府県 === '愛知県') {
        addelem_wrapper_aichi.appendChild(addelem);
      } else if (clinic.都道府県 === '三重県') {
        addelem_wrapper_mie.appendChild(addelem);
      } else if (clinic.都道府県 === '滋賀県') {
        addelem_wrapper_siga.appendChild(addelem);
      } else if (clinic.都道府県 === '京都府') {
        addelem_wrapper_kyouto.appendChild(addelem);
      } else if (clinic.都道府県 === '大阪府') {
        addelem_wrapper_osaka.appendChild(addelem);
      } else if (clinic.都道府県 === '兵庫県') {
        addelem_wrapper_hyougo.appendChild(addelem);
      } else if (clinic.都道府県 === '奈良県') {
        addelem_wrapper_nara.appendChild(addelem);
      } else if (clinic.都道府県 === '和歌山県') {
        addelem_wrapper_wakayama.appendChild(addelem);
      } else if (clinic.都道府県 === '鳥取県') {
        addelem_wrapper_tottori.appendChild(addelem);
      } else if (clinic.都道府県 === '島根県') {
        addelem_wrapper_shimane.appendChild(addelem);
      } else if (clinic.都道府県 === '岡山県') {
        addelem_wrapper_okayama.appendChild(addelem);
      } else if (clinic.都道府県 === '広島県') {
        addelem_wrapper_hiroshima.appendChild(addelem);
      } else if (clinic.都道府県 === '山口県') {
        addelem_wrapper_yamaguti.appendChild(addelem);
      } else if (clinic.都道府県 === '徳島県') {
        addelem_wrapper_tokusima.appendChild(addelem);
      } else if (clinic.都道府県 === '香川県') {
        addelem_wrapper_kagawa.appendChild(addelem);
      } else if (clinic.都道府県 === '愛媛県') {
        addelem_wrapper_ehime.appendChild(addelem);
      } else if (clinic.都道府県 === '高知県') {
        addelem_wrapper_kouchi.appendChild(addelem);
      } else if (clinic.都道府県 === '福岡県') {
        addelem_wrapper_fukuoka.appendChild(addelem);
      } else if (clinic.都道府県 === '佐賀県') {
        addelem_wrapper_saga.appendChild(addelem);
      } else if (clinic.都道府県 === '長崎県') {
        addelem_wrapper_nagasaki.appendChild(addelem);
      } else if (clinic.都道府県 === '熊本県') {
        addelem_wrapper_kumamoto.appendChild(addelem);
      } else if (clinic.都道府県 === '大分県') {
        addelem_wrapper_ooita.appendChild(addelem);
      } else if (clinic.都道府県 === '宮崎県') {
        addelem_wrapper_miyazaki.appendChild(addelem);
      } else if (clinic.都道府県 === '鹿児島県') {
        addelem_wrapper_kagosima.appendChild(addelem);
      } else if (clinic.都道府県 === '沖縄県') {
        addelem_wrapper_okinawa.appendChild(addelem);
      }
    });

    ////HTML該当箇所へ挿入
    //北海道
    elem_hokkaido.appendChild(addelem_wrapper_hokkaido);
    //青森県
    elem_aomori.appendChild(addelem_wrapper_aomori);
    //岩手県
    elem_iwate.appendChild(addelem_wrapper_iwate);
    //宮城県
    elem_miyagi.appendChild(addelem_wrapper_miyagi);
    //秋田県
    elem_akita.appendChild(addelem_wrapper_akita);
    //山形県
    elem_yamagata.appendChild(addelem_wrapper_yamagata);
    //福島県
    elem_fukusima.appendChild(addelem_wrapper_fukusima);
    //茨城県
    elem_ibaragi.appendChild(addelem_wrapper_ibaragi);
    //栃木県
    elem_tochigi.appendChild(addelem_wrapper_tochigi);
    //群馬県
    elem_gunma.appendChild(addelem_wrapper_gunma);
    //埼玉県
    elem_saitama.appendChild(addelem_wrapper_saitama);
    //千葉県
    elem_chiba.appendChild(addelem_wrapper_chiba);
    //東京都
    elem_tokyo.appendChild(addelem_wrapper_tokyo);
    //神奈川県
    elem_kanagawa.appendChild(addelem_wrapper_kanagawa);
    //新潟県
    elem_nigata.appendChild(addelem_wrapper_nigata);
    //富山県
    elem_toyama.appendChild(addelem_wrapper_toyama);
    //石川県
    elem_isikawa.appendChild(addelem_wrapper_isikawa);
    //福井県
    elem_fukui.appendChild(addelem_wrapper_fukui);
    //山梨県
    elem_yamanasi.appendChild(addelem_wrapper_yamanasi);
    //長野県
    elem_nagano.appendChild(addelem_wrapper_nagano);
    //岐阜県
    elem_gifu.appendChild(addelem_wrapper_gifu);
    //静岡県
    elem_sizuoka.appendChild(addelem_wrapper_sizuoka);
    //愛知県
    elem_aichi.appendChild(addelem_wrapper_aichi);
    //三重県
    elem_mie.appendChild(addelem_wrapper_mie);
    //滋賀県
    elem_siga.appendChild(addelem_wrapper_siga);
    //京都府
    elem_kyouto.appendChild(addelem_wrapper_kyouto);
    //大阪府
    elem_osaka.appendChild(addelem_wrapper_osaka);
    //兵庫県
    elem_hyougo.appendChild(addelem_wrapper_hyougo);
    //奈良県
    elem_nara.appendChild(addelem_wrapper_nara);
    //和歌山県
    elem_wakayama.appendChild(addelem_wrapper_wakayama);
    //鳥取県
    elem_tottori.appendChild(addelem_wrapper_tottori);
    //島根県
    elem_shimane.appendChild(addelem_wrapper_shimane);
    //岡山県
    elem_okayama.appendChild(addelem_wrapper_okayama);
    //広島県
    elem_hiroshima.appendChild(addelem_wrapper_hiroshima);
    //山口県
    elem_yamaguti.appendChild(addelem_wrapper_yamaguti);
    //徳島県
    elem_tokusima.appendChild(addelem_wrapper_tokusima);
    //香川県
    elem_kagawa.appendChild(addelem_wrapper_kagawa);
    //愛媛県
    elem_ehime.appendChild(addelem_wrapper_ehime);
    //高知県
    elem_kouchi.appendChild(addelem_wrapper_kouchi);
    //福岡県
    elem_fukuoka.appendChild(addelem_wrapper_fukuoka);
    //佐賀県
    elem_saga.appendChild(addelem_wrapper_saga);
    //長崎県
    elem_nagasaki.appendChild(addelem_wrapper_nagasaki);
    //熊本県
    elem_kumamoto.appendChild(addelem_wrapper_kumamoto);
    //大分県
    elem_ooita.appendChild(addelem_wrapper_ooita);
    //宮崎県
    elem_miyazaki.appendChild(addelem_wrapper_miyazaki);
    //鹿児島県
    elem_kagosima.appendChild(addelem_wrapper_kagosima);
    //沖縄県
    elem_okinawa.appendChild(addelem_wrapper_okinawa);
  };

  const STOREFRONT_ACCESS_TOKEN = '9f6d70c56956706f5d0325f7eb1d23b3';
  const STORE_DOMAIN = 'ks-online2022.myshopify.com';

  const query = `
    query getMetaobjects($type: String!, $first: Int!, $after: String) {
      metaobjects(type: $type, first: $first, after: $after) {
        edges {
          node {
            handle
            type
            fields {
              key
              value
              type
              reference {
                ... on MediaImage {
                  image {
                    url
                    altText
                  }
                }
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `;

  async function fetchMetaobjects(type = 'clinic') {
    const endpoint = `https://${STORE_DOMAIN}/api/2024-10/graphql.json`;
    const limit = 250;
    let hasNextPage = true;
    let after = null;
    let allNodes = [];

    while (hasNextPage) {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({
          query,
          variables: { type, first: limit, after },
        }),
      });

      const result = await response.json();

      if (result.errors) {
        console.error('GraphQL errors:', result.errors);
        throw new Error('Failed to fetch metaobjects');
      }

      const data = result.data.metaobjects;
      const edges = data.edges || [];

      allNodes = allNodes.concat(edges.map((edge) => edge.node));
      hasNextPage = data.pageInfo.hasNextPage;
      after = data.pageInfo.endCursor;
    }

    const formatted = allNodes.map((node) => {
      const obj = {};

      // fields配列をkey-valueマップ化
      node.fields.forEach((field) => {
        obj[field.key] = field.value;
      });

      // 出力フォーマットに変換
      return {
        都道府県: obj.pref || '',
        VICS正式名称: obj.name || '',
        住所: `${obj.city || ''}${obj.address || ''}`,
        TEL: obj.tel || '',
        ZIP: obj.zip || '',
      };
    });

    return formatted;
  }

  fetchMetaobjects('clinic')
    .then((metaobjects) => {
      console.log('取得したメタオブジェクト一覧:', metaobjects);
      addClinicByProvince(metaobjects);
    })
    .catch((err) => {
      console.error('取得エラー:', err);
    });
});